import { useRouter } from 'next/router';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Link from 'next/link';

import { faqs_data_referers } from '#app/pages/rutas-y-cursos/faqs/data';
import FAQs from '#app/UI/organisms/faqs';
import Modal from '#app/UI/molecules/modal';
import ShareModal from '#app/pages/myvideogame/share-modal';
import Layout from '#layout/index';
import { Button, TextField } from '#atoms/index';
import { Toast } from '#components/index';
import { canonicalURL } from '#helpers/canonical-url';
import { regexEmail } from '#helpers/regex';
import { getReferalCode, getUserCheckReferrer } from '#api/user';
import { event } from '#helpers/gtag';

import styles from './index.module.scss';

const Referidos = ({}) => {
  const {
    register,
    setValue,
    handleSubmit,
    errors,
    formState: { isValid }
  } = useForm({ mode: 'onChange' });

  const router = useRouter();
  const [emailConfirm, setEmailConfirm] = useState(false);
  const [urlReferrer, setUrlReferrer] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);
  const [isLogeed, setIsLogeed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const copyToClipboard = () => {
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 1500);
    navigator.clipboard.writeText(urlReferrer).then(
      () => {},
      () => {}
    );

    event('Click', 'Referidos', 'Copiar_enlace_referidos');
  };

  useEffect(async () => {
    if (
      localStorage.getItem('accessToken') !== null &&
      localStorage.getItem('refreshToken') !== null
    ) {
      setIsLogeed(true);
      const referralCode = await getReferalCode();
      setUrlReferrer(`crackthecode.la/cursos?ref=${referralCode.data.value}`);
    } else {
      setIsLogeed(false);
    }
  }, []);

  const onSubmit = async data => {
    const isUser = await getUserCheckReferrer({email: data.guardian_email.toLowerCase()});

    isUser.data.value ? setEmailConfirm(true) : setEmailConfirm(false);

    setValue('guardian_email', '');

    setTimeout(() => {
      setEmailConfirm(false);
    }, 1500);

    event('Click', 'Referidos', 'Enviar_enlace_referidos_por_email');
  };

  return (
    <>
      <Head>
        <title>Crack The Code | Academia de Programación y Tecnología para Niños</title>
        <meta
          name="description"
          content="Academia de ciencia de la computación. Cursos y talleres de programación, robótica educativa, desarrollo de videojuegos y filmación para niños ¡Descubre nuestros cursos!"
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={canonicalURL(router)} />
      </Head>
      <Layout mainType="full_variant">
        <section className={styles.landing_referidos}>
          <div className={styles.ref_left}>
            <div>
              <h1>¡Regala 25%Off y recibe un regalo!</h1>
              {isLogeed && (
                <>
                  <p className={styles.sub_text}>
                    Comparte con tus amigos este enlace personalizado de descuento:
                  </p>
                  <div className={styles.box_copy_link}>
                    <a className={styles.copy_link}>{urlReferrer}</a>
                    <Button onClick={copyToClipboard}>Copiar</Button>
                  </div>
                  {copySuccess ? (
                    <p className={styles.confirm}>
                      ¡Enlace copiado! Puedes pegarlo donde quieras compartirlo.
                    </p>
                  ) : (
                    ''
                  )}
                  <a className={styles.share} onClick={() => setIsOpen(true)}>
                    Compártelo en tus redes
                  </a>

                  <Modal open={isOpen} onClose={() => setIsOpen(false)}>
                    <ShareModal link={urlReferrer} />
                  </Modal>
                </>
              )}
            </div>

            <div className={styles.form_email}>
              {isLogeed == true ? (
                <>
                  <p className="mb-2">o envíalo a sus correos:</p>
                  <form onSubmit={handleSubmit(onSubmit)} className="flex">
                    <div className={styles.field_row}>
                      <TextField
                        id="guardian_email"
                        name="guardian_email"
                        type="guardian_email"
                        variant="purchase-flow"
                        placeholder="Ingresa el correo de un amigo"
                        register={register({
                          required: 'Verifica tu correo electrónico',
                          pattern: {
                            value: regexEmail,
                            message: 'Esto no es un email, intenta con uno válido'
                          }
                        })}
                        error={!!errors.guardian_email}
                      />
                      {errors.guardian_email && (
                        <Toast message={errors.guardian_email.message} mtop=".5rem" />
                      )}
                    </div>
                    <Button>Enviar</Button>
                  </form>
                  {emailConfirm ? (
                    <p className={styles.confirm}>¡Correo enviado con éxito!</p>
                  ) : (
                    ''
                  )}
                </>
              ) : (
                <div className={styles.login}>
                  <h4>
                    Promoción exclusiva para alumnos de <br /> Crack The Code
                  </h4>
                  <p>
                    Si ya eres alumno <Link href="/login">ingresa a tu cuenta</Link>
                  </p>
                </div>
              )}
              {!isLogeed && (
                <>
                  <p className={styles.last_text4}>
                    Cada amigo que se inscriba en Crack The Code usando tu enlace{' '}
                    <strong>recibirá un 25% de descuento </strong> al momento de pagar su
                    curso o ruta.
                  </p>
                  <p className={styles.last_text2}>
                    Y tú, por cada inscrito, recibirás 30 US$ de descuento en el curso o
                    ruta que quieras en Crack The Code.
                  </p>
                </>
              )}
            </div>
          </div>
          <div className={styles.ref_right}>
            <figure>
              <img src="./referidos/referidos-banner.png" />
            </figure>
          </div>
        </section>

        <section className={styles.how_to_function}>
          {isLogeed && (
            <>
              <p className={styles.last_text4}>
                Cada amigo que se inscriba en Crack The Code usando tu enlace{' '}
                <strong>recibirá un 25% de descuento </strong> al momento de pagar su
                curso o ruta.
              </p>
              <p className={styles.last_text2}>
                Y tú, por cada inscrito, recibirás 30 US$ de descuento en el curso o ruta
                que quieras en Crack The Code.
              </p>
            </>
          )}
          <div className={styles.wancho}>
            <h2>¿Cómo funciona?</h2>

            <div className={styles.items_function}>
              <div className={styles.item_function}>
                <figure className={styles.item_img}>
                  <img src="./referidos/Tag.svg" />
                </figure>
                <h5 className={styles.item_h5}>
                  1 . Genera tu enlace <br /> personal
                </h5>
                <p className={styles.item_p}>
                  Con una promoción <br /> de bienvenida.
                </p>
              </div>

              <div className={styles.item_function}>
                <figure className={styles.item_img}>
                  <img src="./referidos/UsersThree.svg" />
                </figure>
                <h5 className={styles.item_h5}>2. ¡Comparte!</h5>
                <p className={styles.item_p}>
                  ¡Comparte tu enlace <br /> con amigos!
                </p>
              </div>

              <div className={styles.item_function}>
                <figure className={styles.item_img}>
                  <img src="./referidos/Gift.svg" />
                </figure>
                <h5 className={styles.item_h5}>
                  3. ¡Recibe tu <br /> regalo!
                </h5>
                <p className={styles.item_p}>
                  Cuando un amigo se <br /> inscriba usando tu <br /> enlace.
                </p>
              </div>
            </div>
          </div>
        </section>

        <FAQs data={faqs_data_referers} />
      </Layout>
    </>
  );
};

export default Referidos;
